export const NAME = "page-garage";